
$(document).on('click', '#PayGlocalCreate', function (e) {
    e.preventDefault();
    $('#payGlocalPGError').addClass('d-none');
    let url = $('#payGlocalUrl').val();
    $.spinner().start();
    $.ajax({
        url,
        type: 'get',
        success(data) {
            $.spinner().stop();
            if(!data.error){
                window.PGPay.launchPayment(
                    { redirectUrl: data.redirectUrl },
                    paymentCallback
                );
            }else{
                $('#payGlocalPGError').removeClass('d-none').addClass('d-flex');
                $('#payGlocalPGError span').html(data.message);
                $("html, body").animate({ scrollTop: 0 }, "slow");
            }
        },
        error() {
            $.spinner().stop();
            console.error(error);
            serviceError.html('Something went wrong');
        },
    });
});

function paymentCallback(data){
    $('#payGlocalPGError').addClass('d-none');
    let payGlocalCallBackUrl = $('#payGlocalCallBackUrl').val();
    $.spinner().start();
    $.ajax({
        url: payGlocalCallBackUrl,
        type: 'post',
        dataType: 'json',
        data: data,
        success: function (responseData) {
            $.spinner().stop();
            if(responseData.success && responseData.redirect ){
                window.location.href = responseData.redirectUrl;
            }else{
                if(responseData.redirect){
                     window.location.href = responseData.redirectUrl;
                }else{
                    $('#payGlocalPGError').removeClass('d-none').addClass('d-flex');
                    $('#payGlocalPGError span').html(responseData.message);
                    $("html, body").animate({ scrollTop: 0 }, "slow");
                }
            }
        },
        error: function () {
         $.spinner().stop();
         console.log('error')
        }
    });
    
}